import { AvatarImage } from './AvatarImage';
import { Professional } from '@aldebaran/prisma';

export interface ProfessionalAvatarProps {
  professional?: Pick<
    Professional,
    'firstname' | 'lastname' | 'avatarId' | 'title' | 'gender'
  >;
  size?: number;
  selectable?: boolean;
  selected?: boolean;
  /** When set, dimensions come from this class instead of the size prop (for responsive sizing) */
  className?: string;
}

export const ProfessionalAvatar = ({
  professional,
  size = 40,
  selectable,
  className,
  selected,
}: ProfessionalAvatarProps) => {
  const alt = `${professional?.title ?? ''} ${professional?.firstname ?? ''} ${
    professional?.lastname ?? ''
  }`.trim();

  return (
    <div
      className={`overflow-hidden rounded-xl bg-[#F5F6F8] z-10 shrink-0 ${
        selected
          ? 'cursor-default'
          : selectable
          ? 'cursor-pointer transition-opacity hover:opacity-95'
          : 'cursor-default'
      } ${className ?? ''}`}
      style={
        className
          ? undefined
          : {
              width: size,
              height: size,
            }
      }
      role="img"
      aria-label={alt || undefined}
    >
      <AvatarImage
        avatarId={professional?.avatarId}
        gender={professional?.gender}
        alt={alt}
      />
    </div>
  );
};
